


















import Vue, { nextTick } from "vue";
import Component from "vue-class-component";
import EventEditorInformation from "@/components/arma/events/editor/EventEditorInformation.vue";
import EventEditorSlotGroups from "@/components/arma/events/editor/EventEditorSlotGroups.vue";
import ModpackService from "@/classes/ModpackService";
import { EventInterface, ModpackInterface, SlotGroupInterface } from "@/types";
import Event from "@/classes/Event";
import EventService from "@/classes/EventService";
import SlotGroup from "@/classes/SlotGroup";

@Component({
  components: { EventEditorInformation, EventEditorSlotGroups },
  metaInfo: {
    title: "Create & Host – Newfound Pioneer Corps Arma 3",
    meta: [
      { vmid: "description", name: "description", content: "Host your own Arma 3 event for the Newfound Pioneer Corps! Set a name, put a small description, pick a mod pack and you are good to go." },
      { vmid: "og:title", property: "og:title", content: "Create & Host – Newfound Pioneer Corps Arma 3" },
      { vmid: "og:description", property: "og:description", content: "Host your own Arma 3 event for the Newfound Pioneer Corps! Set a name, put a small description, pick a mod pack and you are good to go." },
      { vmid: "og:url", property: "og:url", content: "https://arma.npcs.games/events/create" },
    ],
  },
})
export default class EventEditor extends Vue {
  public modpacks: ModpackInterface[] = [];
  public event: Partial<EventInterface> = {
    modpack: 0,
  };

  public async mounted() {
    const copyEventJson = localStorage.getItem("copyEvent");
    if (copyEventJson !== null) {
      this.event = this.getCopyEvent(copyEventJson);
    }

    await this.fetchModpacks();
  }

  public async fetchModpacks() {
    this.modpacks = await ModpackService.getModpacks();
  }

  public async saveEvent() {
    const form: any = this.$refs.form;

    const formValid = await form.validate();
    if (!formValid) {
      return;
    }

    try {
      await EventService.saveEvent(this.event);
      this.$router.push("/events/success");
    } catch (error) {
      this.$store.dispatch("showErrorSnackbar", "Failed to save event. Please try again.");
    }
  }

  public async updateModpack(modpack: number) {
    await this.fetchModpacks();
    this.event.modpack = modpack;
  }

  private getCopyEvent(eventJson: string): Partial<EventInterface> {
    const previous = JSON.parse(eventJson);
    const current: Partial<EventInterface> = {};

    current.name = previous.name;
    current.description = previous.description;
    current.modpack = previous.modpack.id;
    return current;
  }
}
